import { AccordionModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import RequireCss from '@helpers/RequireCss';
import AccordionItem from '@organisms/accordion/AccordionItem';
import RequireJs from '@helpers/RequireJs';
import FigurePicture from '@atoms/pictures/FigurePicture';

const Accordion = (model: AccordionModel) => {
  const styleModifier = getModifiers(model, 'kf-o-accordion');
  const { items, title, subTitle, image, mode, cssPath, isSingleImageMode, leftContent, theme } = model;

  return (
    <div className={styleModifier} data-image={JSON.stringify(image)} data-mode={mode} data-theme={theme ?? 'black'}>
      <div className="kf-container">
        {title || subTitle ? (
          <div className="kf-o-accordion__headings">
            <h2 className="kf-o-accordion__headings-title">{title}</h2>
            {subTitle && <p className="kf-o-accordion__headings-sub-title">{subTitle}</p>}
          </div>
        ) : null}

        <div className="kf-o-accordion__content-container">
          {!isSingleImageMode && <div className="kf-o-accordion__image fading">{image && <FigurePicture {...image} />}</div>}
          {isSingleImageMode && (
            <div className="kf-o-accordion-left-column">
              {leftContent && (
                <div className="kf-o-accordion-left-column__rtb">
                  <div dangerouslySetInnerHTML={{ __html: leftContent.content }} className="kf-rich-text-box" />
                </div>
              )}

              {image && (
                <div className="kf-o-accordion-left-column__image">
                  <FigurePicture {...image} />
                </div>
              )}
            </div>
          )}
          <div className="kf-o-accordion__item-container">
            {items?.map((item) => (
              <AccordionItem key={item.title} {...item} />
            ))}
          </div>
        </div>
      </div>

      <RequireCss path={cssPath ?? 'b-accordion'} />
      <RequireJs defer path={'accordion'} />
    </div>
  );
};

export default Accordion;
